<dx-tree-list
  [dataSource]="dataSource"
  [keyExpr]="keyExpr"
  [parentIdExpr]="parentIdExpr"
  [height]="height"
  [showBorders]="true"
  [columns]="columns"
  [columnAutoWidth]="columnAutoWidth"
  [rowAlternationEnabled]="true"
  (onCellPrepared)="cellPrepared.emit($event)"
  (onRowClick)="rowClicked.emit($event.data)">
  <dxo-selection [mode]="selectionMode"></dxo-selection>
</dx-tree-list>
